import { useNavigate } from 'react-router-dom';

function ImpersonationBanner() {
  const navigate = useNavigate();

  if (sessionStorage.getItem('impersonating') !== '1') return null;

  const username = sessionStorage.getItem('username') || 'this participant';

  const endSession = () => {
    // sessionStorage only — it's per-tab. localStorage is shared across every
    // tab on this origin, so clearing it here would also log out a genuinely
    // active admin session sitting in a different tab.
    sessionStorage.clear();
    if (window.opener) {
      window.close();
    } else {
      navigate('/user-login', { replace: true });
    }
  };

  return (
    <div
      style={{
        background: '#7a3b12',
        color: '#fff',
        padding: '10px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px',
        fontSize: '14px',
      }}
    >
      <span>🔒 Admin session — viewing as <strong>{username}</strong>.</span>
      <button
        onClick={endSession}
        style={{
          background: '#fff',
          color: '#7a3b12',
          border: 'none',
          borderRadius: '4px',
          padding: '4px 12px',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        End session
      </button>
    </div>
  );
}

export default ImpersonationBanner;
